<ng-container *transloco="let t; read: 'formFieldText'">
  <ng-container *ngIf="field.readonly === true">
    <crm-row>
      <header [innerHTML]="field.name"></header>
      <main>{{ readonlyValue$ | async }}</main>
    </crm-row>
  </ng-container>

  <ng-container *ngIf="!field.readonly" [formGroup]="parentFormGroup">
    <mat-form-field class="form-field">
      <mat-label><span [innerHTML]="field.name"></span></mat-label>
      <input
        type="text"
        matInput
        [crmTrimInput]="trimValue"
        [formControlName]="field.key"
        [required]="parentFormGroup.get(field.key).errors?.required"
      />
      <span matPrefix>
        <ng-content select="[prefix]"></ng-content>
      </span>
      <span matSuffix>
        <ng-content select="[suffix]"></ng-content>
      </span>
      <mat-error [ngxErrors]="field.key" #error="ngxErrors">
        <span ngxError="required">{{ t('requiredField') }}</span>
        <span ngxError="minlength">
          {{ t('minlength', { minlength: error.getError('minlength')?.requiredLength }) }}
        </span>
        <span ngxError="maxlength">
          {{ t('maxlength', { maxlength: error.getError('maxlength')?.requiredLength }) }}
        </span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
        <span ngxError="pattern">{{ t('pattern') }}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
</ng-container>
